export const EventTypes = {
  // MIS / data layer sync
  MIS_PLAN_EXPANDED:           'mis.plan.expanded',
  MIS_SERVICE_DRAGGED_TO_PLAN: 'mis.service.dragged_to_plan',
  MIS_DATA_FETCHED:            'mis.data.fetched',

  // Constructor — plan lifecycle
  CONSTRUCTOR_PLAN_CREATED:    'constructor.plan.created',
  CONSTRUCTOR_PLAN_UPDATED:    'constructor.plan.updated',
  CONSTRUCTOR_SERVICE_ADDED:   'constructor.service.added',
  CONSTRUCTOR_SERVICE_DELETED: 'constructor.service.deleted',
  CONSTRUCTOR_STAGE_ADDED:     'constructor.stage.added',

  // Sharing
  CONSTRUCTOR_SHARE_ACTIVATED: 'constructor.share.activated',
  CONSTRUCTOR_SHARE_COPIED:    'constructor.share.copied',

  // Staff auth
  STAFF_AUTH_LOGIN:            'staff.auth.login',
  STAFF_AUTH_LOGOUT:           'staff.auth.logout',
} as const

export type EventType = typeof EventTypes[keyof typeof EventTypes]

export interface EventPayloadMap {
  'mis.plan.expanded':           { mis_plan_id: number; mis_plan_title?: string }
  'mis.service.dragged_to_plan': { mis_plan_id: number; service_name: string; tooth_number?: string; quantity?: number; plan_id: number; stage_id: number }
  'mis.data.fetched':            { mis_plan_id: number; service_count: number }
  'constructor.plan.created':    { plan_id: number; patient_id?: number; title?: string }
  'constructor.plan.updated':    { plan_id: number; fields: string[] }
  'constructor.service.added':   { plan_id: number; stage_id: number; service_name: string }
  'constructor.service.deleted': { plan_id: number; stage_id: number; service_id: number }
  'constructor.stage.added':     { plan_id: number; stage_id: number }
  'constructor.share.activated': { plan_id: number }
  'constructor.share.copied':    { plan_id: number }
  'staff.auth.login':            { phone?: string }
  'staff.auth.logout':           Record<string, never>
}
